import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import { breadcrumbSchema } from '@/components/SEO';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '@/lib/api';

export default function Breadcrumb({ items = [] }) {
    if (!items || items.length === 0) return null;
    const all = [{ name: 'Početna', url: '/' }, ...items];
    const base = (typeof window !== 'undefined' ? window.location.origin : SITE_URL).replace(/\/$/, '');
    const schema = breadcrumbSchema(
        all.map((it) => ({ name: it.name, url: `${base}${it.url}` }))
    );

    return (
        <>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>
            <nav
                aria-label="Putanja navigacije"
                className="flex items-center text-xs text-foreground/60"
                data-testid="breadcrumb"
            >
                <ol className="flex items-center flex-wrap gap-1">
                    {all.map((item, idx) => {
                        const isLast = idx === all.length - 1;
                        return (
                            <li key={item.url} className="flex items-center gap-1">
                                {idx === 0 ? (
                                    <Link to={item.url} className="flex items-center hover:text-foreground">
                                        <Home className="h-3 w-3 mr-1" />
                                        {item.name}
                                    </Link>
                                ) : isLast ? (
                                    <span className="text-foreground/80" aria-current="page">
                                        {item.name}
                                    </span>
                                ) : (
                                    <Link to={item.url} className="hover:text-foreground">
                                        {item.name}
                                    </Link>
                                )}
                                {!isLast && <ChevronRight className="h-3 w-3 text-foreground/40" />}
                            </li>
                        );
                    })}
                </ol>
            </nav>
        </>
    );
}
